import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal, Button } from 'react-bootstrap';
import FailedLogin from "../../images/failed-login.png";
import RoundCloseButton from "../../images/round-close-button.png";

interface ModalFailedLoginProps {
  remainingAttempt: number;
  show: boolean;
  onHide: () => void;
};

function ModalLoginAttempt({
  show,
  onHide,
  remainingAttempt
}: ModalFailedLoginProps) {

  return (
    <Modal
      show={show}
      onHide={() => onHide()}
      id={"failed-login-attempt"}
      centered
    >
      <Modal.Body>
        <KickImage onClick={onHide} className='close-icon' src={RoundCloseButton} alt="..." />
        <p className="title">Hold On</p>
        <p className="text">Password entered does not match the email. Please try again.</p>
        <p className="remaining-info">{`You have ${remainingAttempt || 0} remaining attempts `}</p>
        <Button onClick={() => onHide()}>OK</Button>
      </Modal.Body>
    </Modal>
  );
}

export default ModalLoginAttempt;
